import type { ApiClient } from "../../../infrastructure/http/apiClient";
import { ApiClientError } from "../../../infrastructure/http/apiClient";
import { getAuthMe } from "../../auth";
import { getBillingCapabilities } from "../../billing";
import type { AuthenticatedBootContext } from "../domain/authenticatedBoot";

export async function loadAuthenticatedBoot(apiClient: ApiClient): Promise<AuthenticatedBootContext> {
  const user = await getAuthMe(apiClient);
  const capabilities = await getBillingCapabilities(apiClient);

  if (user.tenant_id !== capabilities.tenant_id) {
    throw new ApiClientError("The authenticated tenant and capabilities tenant do not match.", {
      code: "invalid_response"
    });
  }

  return {
    user,
    capabilities
  };
}
